import { render } from "./SiteDetail.vue?vue&type=template&id=5460eaee&scoped=true"
import script from "./SiteDetail.vue?vue&type=script&lang=js"
export * from "./SiteDetail.vue?vue&type=script&lang=js"

import "./SiteDetail.vue?vue&type=style&index=0&id=5460eaee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5460eaee"]])

export default __exports__